import * as React from 'react';

import SvgIcon from '../SvgIcon';

import styles from './styles.sass';

interface Props {
    icon: string;
    className?: string;
}

const SquareIcon = (props: Props) => {
    const {icon, className} = props;

    return (
        <span className={`${styles['square-icon']} ${className}`}>
            <SvgIcon icon={icon} />
        </span>
    );
};
SquareIcon.defaultProps = {
    className: null,
};

export default SquareIcon;
